import ReactGA4 from "react-ga4";
import { apiService } from "../services/ApiService";
const InitializeGoogleAnalytics = async () => {
  try {
    await apiService
      .get("initialize")
      .then((res) => res?.data || res)
      .then((response) => {
        const site_Key = atob(response?.GOOGLE_ANALYTICS_ID);
        console.debug("Initializing Google Analytics 4");
        if (site_Key) {
          ReactGA4.initialize(site_Key);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  } catch (error) {
    console.error("Error initializing Google Analytics 4:", error);
  }
};

const TrackGoogleAnalyticsEvent = (category, action, label) => {
  ReactGA4.event({
    category: category,
    action: action,
    label: label,
  });
};

export default InitializeGoogleAnalytics;
export { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent };
